type EventHandler<T = never> = (payload: T) => void;

export class EventEmitter<EventMap extends { [K in keyof EventMap]: unknown }> {
  private handlers = new Map<keyof EventMap, EventHandler<any>[]>();

  on<EventName extends keyof EventMap>(
    event: EventName,
    callback: EventHandler<EventMap[EventName]>,
  ) {
    const existing = this.handlers.get(event) || [];
    this.handlers.set(event, [...existing, callback]);
  }

  off<EventName extends keyof EventMap>(
    event: EventName,
    callback: EventHandler<EventMap[EventName]>,
  ) {
    const handlers = this.handlers.get(event) || [];
    this.handlers.set(
      event,
      handlers.filter((handler) => handler !== callback),
    );
  }

  emit<EventName extends keyof EventMap>(event: EventName, payload?: EventMap[EventName]) {
    const handlers = this.handlers.get(event) || [];
    handlers.forEach((handler) => handler(payload));
  }
}
